import { render, staticRenderFns } from "./ElectronicTemplateDetail.vue?vue&type=template&id=0d16ea58&"
import script from "./ElectronicTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ElectronicTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports